import service from '@/utils/server';

const modName='/bd/landcert/';
//查询结算信息
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

//土地证详情
export const details = data => {
  return service({
    url: modName + 'detail',
    method: 'post',
    data
  });
};

//土地证审核通过
export const agree = data => {
  return service({
    url: modName + 'agree',
    method: 'post',
    data
  });
};

//土地证审核拒绝
export const refuse = data => {
  return service({
    url: modName + 'refuse',
    method: 'post',
    data
  });
};

//反审核修改
export const updateLandcert = data => {
  return service({
    url: modName + 'updateLandcert',
    method: 'post',
    data
  });
};

//土地证使用详情
export const useDetail = data => {
  return service({
    url: modName + 'useDetail',
    method: 'post',
    data
  });
};

export const batchDownloadAnnex = data => {
  return service({
    url: modName + 'batchDownloadAnnex',
    method: 'post',
    responseType: 'blob',
    data
  });
};

/**
 * 图片上传
 */
export const uploadUrl = process.env.BASE_URL + '/bd/landcert/documentsImgUpload';




// WEBPACK FOOTER //
// ./src/page/bd/run/landcertInfo/api/index.js